(() => {
  if (window.__myteaCartCountInitialized) return;
  window.__myteaCartCountInitialized = true;

  const renderCount = (count) => {
    const normalizedCount = Number.isFinite(Number(count)) ? Number(count) : 0;

    document.querySelectorAll('[data-mytea-cart-count]').forEach((badge) => {
      badge.textContent = normalizedCount > 99 ? '99+' : String(normalizedCount);
      badge.hidden = normalizedCount < 1;
    });
  };

  const refreshCount = async () => {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });

      if (!response.ok) return;
      const cart = await response.json();
      renderCount(cart.item_count);
    } catch (_) {
      // Keep the server-rendered count if the cart endpoint is temporarily unavailable.
    }
  };

  document.addEventListener('cart:update', () => {
    window.setTimeout(refreshCount, 0);
  });
  document.addEventListener('shopify:section:load', refreshCount);
  window.addEventListener('pageshow', refreshCount);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCount, { once: true });
  } else {
    refreshCount();
  }
})();
